<div style="width: 100wh;height: 100vh;">
    <div class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
</div>

<div style="opacity: 0;">
    <div id="DigitalAggrementSuccessMessage">
        <div class='mb-3'>{{successMessage}}</div>
        <div calss='w-100 ' *ngIf="file">
            <app-files-viewer class="text-left" [files]="[file]"></app-files-viewer>
        </div>
    </div>
</div>